import { useEffect } from 'react';
import useStores from '$src/hooks/useStores';
import { useParams } from 'react-router';
import { controlCenterApi } from '$src/api/control-center-api';
import { sendCloudwatchRUMError } from '$src/utils/cloudwatchRUM';
import { LocationPrincipalDomain } from '$src/api/constants';

function useLocationId() {
  const { locationId: paramsLocationId } = useParams();
  const { locationStore, sessionStore } = useStores();

  const shouldUpdateLocation =
    (paramsLocationId && locationStore.locationId !== paramsLocationId) || (!locationStore.locationId && locationStore.locations?.length === 1);

  useEffect(() => {
    async function fetch(locationId) {
      sessionStore.setLoading(true);
      try {
        const response = await controlCenterApi.fetchFeatures(LocationPrincipalDomain, locationId);
        sessionStore.setFeatureFlags(response, LocationPrincipalDomain);
      } catch (error) {
        sendCloudwatchRUMError(`There was an error fetching features for principalDomain=${LocationPrincipalDomain} principal=${locationId}`, error);
      }

      sessionStore.setLoading(false);
    }

    if (shouldUpdateLocation) fetch(locationStore.locationId);
  }, [locationStore.locationId, sessionStore, shouldUpdateLocation]);
  
  if (shouldUpdateLocation) {
    locationStore.setLocationId(paramsLocationId || locationStore.locations[0].locationId);
  }

  return locationStore.locationId;
}

export default useLocationId;
